import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton, InputAdornment, InputBase, Paper, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CancelIcon from '@mui/icons-material/Cancel';
import { eliminarComentarioTaller as eliminarComentarioTallerApi, getTarea, getTareaTaller, postComentarioTaller, postComentarioTarea, verificarToken } from '../../services/apis';
import { useParams } from 'react-router-dom';
import TextsmsIcon from '@mui/icons-material/Textsms';
import SendIcon from '@mui/icons-material/Send';
import { RegistroAccionesCard } from '../../utils/componentes-utiles/RegistroAccionesCard';
import { convertirEnlaces, textoMayusculas } from '../../utils/utils';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

export const TareaTallerDialog = ({ open, setOpen, tareaInfo, handleEvent, backgroundCard, textColor }) => {
    const handleClose = () => {
        setOpen(false);
    };

    const [tarea, setTarea] = useState(tareaInfo);
    const [tareaAcciones, setTareaAcciones] = useState([]);

    //aux
    const mensajePorDefecto = [{
        autor: "3",
        color: "7303fc",
        comentario: "Escribe un Comentario",
    }];
    //utils
    const [comentarios, setComentarios] = useState([]);
    const [extras, setExtras] = useState([]);
    const [mensaje, setMensaje] = useState('');
    const [opciones, setOpciones] = useState([]);
    const [puedeEliminarComentarios, setPuedeEliminarComentarios] = useState(false);
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
    const [comentarioAEliminar, setComentarioAEliminar] = useState(null);


    const param = useParams();

    const handleInputChange = (event) => {
        setMensaje(event.target.value);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            enviarComentario();
        }
    };


    const cargarTareas = async () => {
        try {
            const response = await getTareaTaller(tarea.id);
            const responseSesion = await verificarToken();
            setPuedeEliminarComentarios(String(responseSesion?.rol) === '986');
            setComentarios(response.data.comentarios.length > 0 ? response.data.comentarios : mensajePorDefecto);
            setTareaAcciones(response.data.acciones.length > 0 ? response.data.acciones : []);
            setExtras(response.data.extras.length > 0 ? response.data.extras : [])
        } catch (error) {
            console.error("Error al añadir el cliente:", error);
        }
    }

    const abrirConfirmacionEliminar = (comentario) => {
        setComentarioAEliminar(comentario);
        setOpenConfirmDelete(true);
    };

    const cerrarConfirmacionEliminar = () => {
        setOpenConfirmDelete(false);
        setComentarioAEliminar(null);
    };

    const confirmarEliminarComentario = async () => {
        if (!comentarioAEliminar?.id) return;

        await eliminarComentario(comentarioAEliminar.id);
        cerrarConfirmacionEliminar();
    };

    const eliminarComentario = async (idComentario) => {
        try {
            const response = await eliminarComentarioTallerApi(idComentario);

            if (response?.success) {
                setComentarios((prev) => prev.filter((comentario) => String(comentario.id) !== String(idComentario)));
                cargarTareas();
            }
        } catch (error) {
            console.error("Error al eliminar el comentario:", error);
        }
    }

    const enviarComentario = async () => {

        if (mensaje != '') {
            let temp = [...comentarios];
            let nuevoComentario = {
                autor: "1",
                color: '#FFFFFFF',
                comentario: mensaje,
                fecha: "2024-06-10",
                nombre: localStorage.username,
                id_tarea: tarea.id,
                id_proyecto: tarea.id_proyecto
            }
            try {
                const response = await postComentarioTaller(nuevoComentario);


            } catch (error) {
                console.error("Error al añadir el cliente:", error);
            }

            temp.push(nuevoComentario);
            setMensaje('')
            cargarTareas()
        }

    }

    const getContraryColor = (hexColor) => {
        // Validar que el color sea un string
        if (typeof hexColor !== 'string') {
            throw new Error('El color debe ser una cadena de texto');
        }

        // Limpiar el color (remover # si existe)
        let cleanHex = hexColor.replace('#', '');

        // Validar formato
        if (!/^[0-9A-Fa-f]{6}$/.test(cleanHex) && !/^[0-9A-Fa-f]{3}$/.test(cleanHex)) {
            throw new Error('Formato de color hexadecimal inválido');
        }

        // Expandir formato corto (3 dígitos) a formato largo (6 dígitos)
        if (cleanHex.length === 3) {
            cleanHex = cleanHex.split('').map(char => char + char).join('');
        }

        // Convertir a RGB
        const r = parseInt(cleanHex.substring(0, 2), 16);
        const g = parseInt(cleanHex.substring(2, 4), 16);
        const b = parseInt(cleanHex.substring(4, 6), 16);

        // Calcular el color contrario (invertir cada componente)
        const contraryR = 255 - r;
        const contraryG = 255 - g;
        const contraryB = 255 - b;

        // Ajustar brillo - hacerlo más vibrante
        const adjustBrightness = (value) => {
            // Aumentar el contraste para hacerlo más brillante
            if (value < 128) {
                return Math.min(255, value + 12); // Aumentar valores oscuros
            } else {
                return Math.min(255, value + 128); // Aumentar ligeramente valores claros
            }
        };

        // Aplicar ajuste de brillo
        const brightR = adjustBrightness(contraryR);
        const brightG = adjustBrightness(contraryG);
        const brightB = adjustBrightness(contraryB);

        // Convertir a hexadecimal
        const brightHexR = Math.round(brightR).toString(16).padStart(2, '0');
        const brightHexG = Math.round(brightG).toString(16).padStart(2, '0');
        const brightHexB = Math.round(brightB).toString(16).padStart(2, '0');

        return `#${brightHexR}${brightHexG}${brightHexB}`.toUpperCase();
    };
    const precioTotalExtras = (extras) => {
        let total = 0;

        extras.forEach(ext => {
            total = total + ext.precio;
        });
        return total;
    }


    useEffect(() => {
        if (open === true) {
            cargarTareas();
        }
    }, [open])



    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth="xl"
        >
            <DialogContent style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor
            }}>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    xs={12}
                    sx={{ mb: 3 }}
                >
                    <Typography variant='h4'>
                        ID: {tarea.id}
                    </Typography>
                    <Typography variant='h4'> {tarea.asunto}</Typography>

                    <CancelIcon variant='contained' className='pointer' onClick={handleClose} sx={{ fontSize: 30 }}></CancelIcon>
                </Grid>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="start"
                    xs={12}
                >
                    <Grid
                        container
                        direction="column"
                        justifyContent="start"
                        alignItems="start"
                        xs={12} md={5.8}
                        sx={{ mb: 3, minHeight: '40vh' }}
                        gap={2}
                    >
                        <Grid
                            container
                            direction="column"
                            justifyContent="start"
                            alignItems="start"
                            xs={12}
                        >
                            <Typography variant='h6'>
                                Datos del cliente
                            </Typography>

                            <Typography variant='subtitle1'>
                                <strong>Cliente: </strong>{textoMayusculas(tarea.cliente)}
                            </Typography>

                            <Typography variant='subtitle1'>
                                <strong> Nombre: </strong> {textoMayusculas(tarea.nombre_cliente)}
                            </Typography>

                            <Typography variant='subtitle1'>
                                <strong> Telefono:</strong> {tarea.telefono}
                            </Typography>

                            <Typography variant='subtitle1' sx={{ display: tarea.correo != null ? 'flex' : 'none' }}>
                                <strong> Correo electronico:</strong> {tarea.correo}
                            </Typography>
                        </Grid>

                        <Divider variant="fullWidth" sx={{ minWidth: '100%' }} />

                        <Grid
                            container
                            direction="column"
                            justifyContent="start"
                            alignItems="start"
                            xs={12}
                        >
                            <Typography variant='h6'>
                                Datos de la tarea
                            </Typography>

                            <Typography variant='subtitle1'>
                                <strong> Asunto:</strong> {tarea.asunto}
                            </Typography>

                            <Typography variant='subtitle1'>
                                <strong> Descripción:</strong> {tarea.descripcion}
                            </Typography>

                            <Typography variant='subtitle1' sx={{ display: tarea.contrasena != null ? 'flex' : 'none' }}>
                                <strong> Contraseña:</strong> {tarea.contrasena}
                            </Typography>

                            <Typography variant='subtitle1' sx={{ display: tarea.contrasena != null ? 'flex' : 'none' }}>
                                <strong> Cargador:</strong> {tarea.cargador == 1 ? 'Si' : 'No'}
                            </Typography>

                            <Typography variant='subtitle1' sx={{ display: tarea.contrasena != null ? 'flex' : 'none' }}>
                                <strong> Funda:</strong> {tarea.funda == 1 ? 'Si' : 'No'}
                            </Typography>

                            <Typography variant='subtitle1' sx={{ display: tarea.contrasena != null ? 'flex' : 'none' }}>
                                <strong> Maletin/Bolsa:</strong> {tarea.maletin == 1 ? 'Si' : 'No'}
                            </Typography>

                            <Typography variant='subtitle1'>
                                <strong> Estado:</strong> {tarea.estado_nombre}
                            </Typography>

                            <Typography variant='subtitle1'>
                                <strong> Fecha:</strong> {tarea.fecha}
                            </Typography>
                        </Grid>

                        <Divider variant="fullWidth" sx={{ minWidth: '100%' }} />

                        <Grid
                            container
                            direction="column"
                            justifyContent="start"
                            alignItems="start"
                            xs={12}
                            sx={{ display: tarea.presupuesto != null ? 'flex' : 'none' }}
                        >

                            <Typography variant='h6'>
                                Datos del presupuesto
                            </Typography>

                            <Typography variant='subtitle2'>
                                <strong> Presupuesto:</strong> {tarea.presupuesto}€
                            </Typography>

                            <Typography variant='subtitle1'>
                                {tareaInfo.iva === 1
                                    ? <Typography variant="subtitle1">
                                        <strong>IVA: </strong>IVA incluido
                                    </Typography>
                                    : <Typography variant="h4" sx={{ fontWeight: 800, color: getContraryColor(backgroundCard) }}>
                                        IVA: IVA NO incluido
                                    </Typography>
                                }
                            </Typography>

                            <Typography variant='subtitle2' sx={{ display: extras.length == 0 ? 'none' : 'flex' }}>
                                <strong> Articulos extra:&nbsp;</strong>{precioTotalExtras(extras)}€
                            </Typography>

                            <Typography variant='subtitle1' sx={{ display: extras.length == 0 ? 'none' : 'flex' }}>
                                <strong> Total:&nbsp;</strong>{(parseInt(tarea.presupuesto) + precioTotalExtras(extras))}€
                            </Typography>



                            <Typography variant='subtitle1'>
                                {tareaInfo.comentario_presupuesto != '' && (
                                    <>
                                        <strong> Comentarios del presupuesto:</strong> {tarea.comentario_presupuesto}
                                    </>
                                )}
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            direction="row"
                            justifyContent="start"
                            alignItems="center"
                            xs={12}
                            sx={{ display: extras.length == 0 ? 'none' : 'flex' }}
                        >
                            <Divider variant="fullWidth" sx={{ minWidth: '100%' }} />

                            <Typography variant='h6' gutterBottom>
                                Articulos Extra
                            </Typography>
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                xs={12}
                                gap={1}
                            >
                                {extras.map((ext, index) => (
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        xs={12}
                                        className='articulo-extra'
                                        sx={{ p: 1 }}
                                    >
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="start"
                                            alignItems="center"
                                            xs={'auto'}
                                            gap={1}
                                        >
                                            <IconButton>
                                                <DeleteForeverIcon />
                                            </IconButton>
                                            <Typography variant='subtitle1'>
                                                {ext.descripcion}
                                            </Typography>
                                        </Grid>

                                        <Typography variant='subtitle1'>
                                            Precio: <strong>{ext.precio}€</strong>
                                        </Typography>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>




                    {comentarios.length >= 0 && (
                        <Grid
                            container
                            direction="column"
                            justifyContent="start"
                            alignItems="start"
                            xs={12} md={5.8}
                        >
                            <div className='envase-chat'>
                                <strong>&nbsp;Comentarios:</strong>
                                <div className='contenedor-chat'>
                                    {comentarios.map((comentario => (

                                        <Grid
                                            container
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="center"
                                            xs={10}
                                            className={`bocadillo-chat ${comentario.autor == 1 ? 'autor' : ''}`}
                                            key={comentario.id}
                                        >
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="space-between"
                                                alignItems="start"
                                                xs={12}
                                            >
                                                <Typography variant='subtitle1' sx={{ color: comentario.color, textAlign: 'left' }} >
                                                    <strong>{comentario.nombre}</strong>
                                                </Typography>
                                                {puedeEliminarComentarios && comentario.id && (
                                                    <Tooltip title="Eliminar comentario" arrow>
                                                        <IconButton
                                                            size="small"
                                                            color="error"
                                                            onClick={() => abrirConfirmacionEliminar(comentario)}
                                                        >
                                                            <DeleteForeverIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </Grid>
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="start"
                                                alignItems="start"
                                                xs={12}
                                            >
                                                <Typography variant='body2' className='texto-con-salto'>
                                                    {convertirEnlaces(comentario.comentario)}
                                                </Typography>
                                            </Grid>
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="end"
                                                alignItems="end"
                                                xs={12}
                                            >
                                                <Typography variant='caption'>
                                                    <strong>{comentario.fecha}</strong>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    )))}

                                </div>
                                <Grid xs={12} className='chat-bar'>
                                    <Paper
                                        component="form"
                                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: '100%', backgroundColor: '#e1e0e0' }}
                                        variant='outlined'
                                        onSubmit={(e) => { e.preventDefault(); enviarComentario(); }}
                                    >
                                        <InputBase
                                            sx={{ ml: 1, flex: 1 }}
                                            placeholder="Escribe un mensaje nuevo"
                                            inputProps={{ 'aria-label': 'Escribe un mensaje nuevo' }}
                                            value={mensaje}
                                            onChange={handleInputChange}
                                            onKeyPress={handleKeyPress}
                                        />
                                        <IconButton type="button" sx={{ p: '10px' }} aria-label="send" >
                                            <SendIcon onClick={() => enviarComentario()} />
                                        </IconButton>
                                    </Paper>
                                </Grid>

                            </div>
                            <Grid container xs={12} justifyContent="center" direction="row" alignItems="start"  >
                                <RegistroAccionesCard acciones={tareaAcciones} />
                            </Grid>
                        </ Grid>

                    )}
                </Grid>


            </DialogContent>
            {/* <DialogActions style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor
            }}> */}
            {/* {opciones.map((opcion, index) => (
                    <Grid container xs={3} sm={3} md={3} xl={3} gap={1} justifyContent="space-around" alignItems="center">
                        <Button
                            variant='contained'
                            className='button-default'
                            key={index}
                            onClick={() => handleEvent(opcion.id_estado)}
                            disabled={
                                opcion.id_estado == 4 ? tarea.id_estado != 3 :
                                    tarea.id_estado == 3 && opcion.id_estado != 4
                                        ? true
                                        : (tarea.id_estado == 1)
                                            ? (tarea.id_estado == 1)
                                            : (tarea.id_estado == 2)}
                        >
                            {opcion.nombre}
                        </Button>
                    </Grid>

                ))} */}
            {/* </DialogActions> */}

            <Dialog
                open={openConfirmDelete}
                onClose={cerrarConfirmacionEliminar}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>
                    Eliminar comentario
                </DialogTitle>

                <DialogContent>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                        ¿Seguro que quieres eliminar este comentario?
                    </Typography>

                    {comentarioAEliminar?.comentario && (
                        <Typography
                            variant="body2"
                            sx={{
                                p: 1.5,
                                backgroundColor: '#f5f5f5',
                                color: '#000',
                                borderRadius: 1,
                                maxHeight: 120,
                                overflow: 'auto'
                            }}
                        >
                            {comentarioAEliminar.comentario}
                        </Typography>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={cerrarConfirmacionEliminar}
                    >
                        Cancelar
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        onClick={confirmarEliminarComentario}
                    >
                        Eliminar
                    </Button>
                </DialogActions>
            </Dialog>

        </Dialog>
    )
}
